import React from "react";
import {
  TableCellsIcon,
  ExclamationTriangleIcon,
  ClockIcon
} from "@heroicons/react/24/outline";

const TableInfoBar = ({
  companyName,
  activeStatement,
  rowsCount,
  columnsCount,
  pendingChanges,
  lastSaveTime
}) => {
  return (
    <div className="mb-4 p-3 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2">
            <TableCellsIcon className="h-5 w-5 text-gray-500" />
            <span className="text-sm font-medium text-gray-700">
              {companyName} - {activeStatement}
            </span>
          </div>
          <div className="text-xs text-gray-500">
            {rowsCount} rows × {columnsCount} columns
          </div>
        </div>
        
        <div className="flex items-center gap-2 text-xs text-gray-500">
          {pendingChanges > 0 && (
            <div className="flex items-center gap-1 bg-yellow-100 text-yellow-800 px-2 py-1 rounded">
              <ExclamationTriangleIcon className="h-3 w-3" />
              <span>{pendingChanges} unsaved change(s)</span>
            </div>
          )}
          {lastSaveTime && (
            <div className="flex items-center gap-1">
              <ClockIcon className="h-3 w-3" />
              <span>Last saved: {new Date(lastSaveTime).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TableInfoBar;